<ng-container *ngIf="initComplete && currentBlockDates.length > 0">
    <b>Included Dates</b><br>
    <div class="dw-pills">
        <div *ngFor="let blockDate of currentBlockDates" class="dw-pill active">
            {{ blockDate.description }}
        </div>
    </div>
</ng-container>

<!-- Airport Validation: {{airportLocationValidationResults | json}} -->

<ng-container *ngIf="initComplete && currentBlockDates.length == 0 && showDateSelection">
    <div dwRow>
        <div dwCol="12">
            <label class="label">Type</label>
            <dw-radio-lookup [(ngModel)]="blockItemTypeId" [lookupId]="blockItemTypeLookupId"
                (ngModelChange)="onDataChange()">
            </dw-radio-lookup>
        </div>
    </div>

    <ng-container *ngIf="blockItemTypeId == BlockItemTypes.IndividualDay">
        <div dwRow>
            <div dwCol="12">
                <label class="label">Dates</label>
                <dw-date-multi-select [(ngModel)]="selectedDates"
                    (ngModelChange)="onDataChange()"></dw-date-multi-select>
            </div>
        </div>

        <div dwRow>
            <div dwCol="6">
                <label class="label">Start Time</label>
                <dw-date2 [(ngModel)]="startTime" (ngModelChange)="onDataChange()" showTime="true"
                    timeOnly="true"></dw-date2>
            </div>
            <div dwCol="6">
                <label class="label">End Time</label>
                <dw-date2 [(ngModel)]="endTime" (ngModelChange)="onDataChange()" showTime="true"
                    timeOnly="true"></dw-date2>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="blockItemTypeId == BlockItemTypes.DateRange">
        <div dwRow>
            <div dwCol="12">
                <label class="label">Date Range </label>
                <dw-date-range-input [(startDate)]="startDate" [(endDate)]="endDate" (startDateChange)="onDataChange()"
                    (endDateChange)="onDataChange()"></dw-date-range-input>
            </div>
        </div>
        <div dwRow>
            <div dwCol="12">
                <label class="label">Bookings Days</label>
                <dw-search-select-lookup [(ngModel)]="bookingScheduleId" (ngModelChange)="onDataChange()"
                    [lookupId]="scheduleLookupId" [paramValues]="scheduleLookupParams"
                    showBlankOption="true"></dw-search-select-lookup>
            </div>
        </div>
    </ng-container>

</ng-container>